globalThis.redoStorefront = {
  type: "commentsold",
  storeUrl: (globalThis as any)?.cs?.shopInfo?.id
    ? `${(globalThis as any).cs.shopInfo.id}.commentsold.com`
    : location.host,
  env: {
    IPIFY_API_KEY: "at_S8q5xe1hwi5jKf6CSb4V661KXTKK2",
    REDO_API_CLIENT_VERSION: "",
    REDO_API_URL: "https://shopify-cdn.getredo.com",
    REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
    REDO_SHOPIFY_EXTENSION_URL: "auto",
    AMPLITUDE_API_KEY: "4ea5fb67e1313890e096ab17cce5d093",
  },
};
globalThis.process = {
  env: {
    IPIFY_API_KEY: "at_S8q5xe1hwi5jKf6CSb4V661KXTKK2",
    REDO_API_CLIENT_VERSION: "",
    REDO_API_URL: "https://shopify-cdn.getredo.com",
    REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
    REDO_SHOPIFY_EXTENSION_URL: "auto",
    AMPLITUDE_API_KEY: "4ea5fb67e1313890e096ab17cce5d093",
  },
};
